// extracted by mini-css-extract-plugin
export default {"WorldAnimation":"WorldAnimation_WorldAnimation__BS1r5","whiteAnimation":"WorldAnimation_whiteAnimation__B7Mcq","spin":"WorldAnimation_spin__j5Jfl"};